import React, { useEffect, useState } from 'react'
import { Col, Empty, Image, Row, Space, Tabs } from 'antd'
import { DetailDrawer } from 'Components/common/MainLayout'
import styled from 'styled-components'
import { selectCurrentUser } from 'Store/user/selector'
import RootState from 'typings/RootState'
import { connect, useDispatch } from 'react-redux'
import { LoadingView } from 'Components/modal'
import {
  formatDateWithoutTime,
  formatTimeWithoutDate,
  getEarnPointTitle,
  getMemberEarnPointStatus,
} from 'helpers/format'
import { MyTheme } from 'Components/common/Theme'
import { Pagination } from 'Components/Pagination'
import { getBurnPointHistoryAPI, getEarnPointHistoryAPI } from 'Store/member-point/api'
import {
  BurnPointData,
  BurnPointHistoryReq,
  EarnPointData,
  EarnPointHistoryReq,
} from 'Store/member-point/types'
import { selectBurnPointHistory, selectEarnPointHistory } from 'Store/member-point/selector'
import { EarnPointType, ImageFallback } from 'helpers/constanst'
import PointSummary from './PointSummary'
import { appConfig } from 'config'
const { TabPane } = Tabs

type Props = {
  isShow: boolean
  onClose: () => void
  id: number
} & ReduxProps

const MemberPointHistory = (props: Props) => {
  const { isShow, onClose, currentUser, pointHistory, pointRedeem, id } = props
  const [activeTab, setActiveTab] = useState('1')
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 10,
  })

  const onClickSearch = () => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  useEffect(() => {
    if (pagination.Page === 1) return
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }, [])

  const dispatch = useDispatch()

  const onGetHistoryList = (): void => {
    if (!isShow) return
    const req: EarnPointHistoryReq = {
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      member_id: id,
      order_by: 'created_at',
      sort: 'desc',
    }
    dispatch(getEarnPointHistoryAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onGetRedeemList = (): void => {
    if (!isShow) return
    const req: BurnPointHistoryReq = {
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      member_id: id,
      order_by: 'created_at',
      sort: 'desc',
    }
    dispatch(getBurnPointHistoryAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  useEffect(() => {
    if (currentUser?.accessToken) {
      if (activeTab === '1') {
        onGetHistoryList()
      } else {
        onGetRedeemList()
      }
    }
  }, [pagination])

  useEffect(() => {
    if (isShow) {
      if (activeTab === '1') {
        onGetHistoryList()
      } else {
        onGetRedeemList()
      }
    }
  }, [isShow])

  const getGroupData = (data: any[]) => {
    const groups = data?.reduce((groups, item) => {
      const date = (item?.created_at || item?.created_at).split('T')[0]
      if (!groups[date]) {
        groups[date] = []
      }
      groups[date].push(item)
      return groups
    }, {})

    // Edit: to add it in the array format instead
    return Object.keys(groups).map(date => {
      return {
        date,
        datas: groups[date],
      }
    })
  }

  const getOrderChanel = (data: EarnPointData) => {
    let title = ''
    switch (data.order_channel) {
      case 'pos':
        title = 'Terminal'
        break
      case 'supplier':
        title = 'ระบบขายราคาพิเศษ'
        break

      default:
        title = data.order_channel
        break
    }
    return title
  }

  const getPointInfo = (data: EarnPointData) => {
    const status = getMemberEarnPointStatus(data.status)
    return (
      <Content>
        <div>
          <Row justify="space-between">
            <Col>
              <Title>{getEarnPointTitle(data)}</Title>
            </Col>
            <Col>
              {data.point < 0 ? <PointRed>{data.point}</PointRed> : <PointGreen>+{data.point}</PointGreen>}{' '}
              คะแนน
            </Col>
          </Row>
          {data?.point_type === EarnPointType.ORDER || data?.point_type === EarnPointType.ORDER_MANUAL ? (
            <Space direction="vertical">
              <OrderNo>{`เลขที่สั่งซื้อ : ${data.order_no}`}</OrderNo>
              <OrderNo>{`ช่องทาง : ${getOrderChanel(data)}`}</OrderNo>
              <OrderNo>{`พนักงานขาย : ${data.update_by || '-'}`}</OrderNo>
            </Space>
          ) : (
            <Space direction="vertical">
              <OrderNo>{`โดย : ${data.update_by || '-'}`}</OrderNo>
              <OrderNo>{`เหตุผล : ${data.reason || '-'}`}</OrderNo>
              <OrderNo>{`หมายเหตุ : ${data.remark || '-'}`}</OrderNo>
            </Space>
          )}
          <Row justify="space-between" align="middle">
            <Col>
              <Date>เวลา {formatTimeWithoutDate(data.created_at)} นาที</Date>
            </Col>
            <Col>
              <Status>
                สถานะ : <span style={{ color: status.color }}>{status.text} </span>
              </Status>
            </Col>
          </Row>
        </div>
      </Content>
    )
  }

  const getRedeemPointInfo = (data: BurnPointData) => {
    return (
      <Content>
        <Row gutter={[24, 8]} justify="space-between" wrap={false}>
          <Col md={3} xs={4}>
            <ThumbImage
              width={'100%'}
              src={appConfig.assetCdnEndpoint + data.image_url}
              fallback={ImageFallback}
            />
          </Col>
          <Col md={21} xs={20}>
            <Space direction="vertical" style={{ width: '100%' }} size="small">
              <Row justify="space-between">
                <Col>คุณได้ใช้คะแนนแลกของรางวัล</Col>
                <Col>
                  <PointRedeem>-{data.burn_value}</PointRedeem> คะแนน
                </Col>
              </Row>
              <OrderNo>{data.title || '-'}</OrderNo>
              <Row justify="space-between">
                <Col>
                  <Date>เวลา {formatTimeWithoutDate(data.created_at)} นาที</Date>
                </Col>
              </Row>
            </Space>
          </Col>
        </Row>
      </Content>
    )
  }

  const meta = activeTab === '1' ? pointHistory.meta : pointRedeem.meta
  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
    />
  )

  return (
    <DetailDrawer
      title={`ประวัติการสะสมคะแนน`}
      width={'50%'}
      onCloseDrawer={onClose}
      visible={isShow}
      footer={null}
      maskClosable={true}
    >
      <LoadingView isShow={pointHistory.event.IsLoading || pointRedeem.event.IsLoading} />
      <PointSummary id={id} visible={isShow} />
      <Tabs
        defaultActiveKey="1"
        onChange={val => {
          setActiveTab(val)
          onClickSearch()
        }}
      >
        <TabPane tab="การสะสมคะแนน" key="1">
          {pointHistory && pointHistory.data.length > 0 ? (
            getGroupData(pointHistory.data).map((item, index) => {
              return (
                <Row key={index}>
                  <Col span={24}>
                    <Header>วันที่ {formatDateWithoutTime(item.date)}</Header>
                    <Row>
                      {item?.datas.map((data: EarnPointData, index: number) => {
                        return (
                          <Col span={24} key={index}>
                            {getPointInfo(data)}
                          </Col>
                        )
                      })}
                    </Row>
                  </Col>
                </Row>
              )
            })
          ) : (
            <Empty />
          )}
        </TabPane>
        <TabPane tab="การแลกของรางวัล" key="2">
          {pointRedeem && pointRedeem.data.length > 0 ? (
            getGroupData(pointRedeem.data).map((item, index) => {
              return (
                <Row key={index}>
                  <Col span={24}>
                    <Header>วันที่ {formatDateWithoutTime(item.date)}</Header>
                    <Row>
                      {item?.datas.map((data: BurnPointData, index: number) => {
                        return (
                          <Col span={24} key={index}>
                            {getRedeemPointInfo(data)}
                          </Col>
                        )
                      })}
                    </Row>
                  </Col>
                </Row>
              )
            })
          ) : (
            <Empty />
          )}
        </TabPane>
      </Tabs>
      <br />
      <Row>
        <Col span={24}>{PaginationContent}</Col>
      </Row>
    </DetailDrawer>
  )
}

const Header = styled.div`
  padding: 10px 20px;
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.medium};
`

const Title = styled.div`
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
`

const Content = styled.div`
  padding: 10px 20px;
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  border-bottom: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
`

const OrderNo = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
`

const Date = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body5};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-style: italic;
`

const Status = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
`

const PointGreen = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.title1};
  color: green;
`

const PointRed = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.title1};
  color: red;
`

const PointRedeem = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.title1};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.error};
`

const ThumbImage = styled(Image)`
  border-radius: 5px;
  width: 100%;
  object-fit: contain;
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    pointHistory: selectEarnPointHistory(state),
    pointRedeem: selectBurnPointHistory(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(MemberPointHistory)
